import React from 'react';
import { injectIntl } from 'react-intl';
import { Row, Col, Tab, NavItem, Nav } from 'react-bootstrap';
import { SECTIONS_DATA, TOOLS } from './igroadmap_components/constants';
import { IntlProvider } from 'react-intl';
import defaultLocales from '../locales/default.json';
import pitchLocales from '../locales/pitch.json';

@injectIntl
class Responsibilities extends React.Component {
  render() {
    const { intl, current, sectionName } = this.props;

    //console.log('Current', current);

    return (
      <Tab.Container id="tabs" defaultActiveKey={current}>
        <Row>
          <Col xs={12} className="wizard product">
            <div className="wizard-inner">
              <div
                className="connecting-line"
                style={{
                  width: `${100 -
                    100 / SECTIONS_DATA.get(sectionName).tools.length}%`
                }}
              />
              <Nav className="nav-tabs">
                {SECTIONS_DATA.get(sectionName).tools.map((tool, id) => (
                  <NavItem
                    onClick={() => {
                      Turbolinks.visit(
                        this.props.toolsPaths[
                          `${tool.prefix ? tool.prefix : ''}${tool.name}`
                        ]
                      );
                    }}
                    key={tool.name}
                    title={intl.formatMessage({ id: `${tool.name}_help` })}
                    style={{
                      width: `${100 /
                        SECTIONS_DATA.get(sectionName).tools.length}%`
                    }}
                    eventKey={tool.name}
                  >
                    <span className="round-tab">
                      <h5 className="text-icon">
                        {intl.formatMessage({ id: tool.name })}
                      </h5>
                      <i className={tool.icon} />
                    </span>
                  </NavItem>
                ))}
              </Nav>
            </div>
          </Col>
        </Row>
      </Tab.Container>
    );
  }
}

const Main = props => (
  <IntlProvider
    locale={props.userLocale}
    messages={{
      ...pitchLocales[props.userLocale],
      ...defaultLocales[props.userLocale]
    }}
  >
    <Responsibilities {...props} />
  </IntlProvider>
);
export default Main;
